import { createContext, useContext, useState } from "react";

const ApprovalsContext = createContext();

export const ApprovalsProvider = ({ children }) => {
  const [approvals, setApprovals] = useState();
  return (
    <ApprovalsContext.Provider value={{ approvals, setApprovals }}>
      {children}
    </ApprovalsContext.Provider>
  );
};
export const useApproval = () => useContext(ApprovalsContext);
